import { createPortal } from 'react-dom';
import { useRef } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { isSet } from "../../../models/model-types-methods";
import './sticky-toolbar.scss';

enum STICKY_TOOLBAR_PLACEMENT {
    BOTTOM = 'bottom',
    /** We can extend component to allow to place toolbar to top, left or right */
}

export interface IProps {
    placement?: STICKY_TOOLBAR_PLACEMENT;
    width?: number;
    onResize?: (arg: { width?: number; height?:number; }) => void;
    children: React.ReactNode;
}

const StickyToolbar: React.FC<IProps> = ({ placement = STICKY_TOOLBAR_PLACEMENT.BOTTOM, children, width, onResize }) => {
    const parentElement = document.body;
    const stickyToolbarRef = useRef<HTMLDivElement>(null);

    useResizeDetector<HTMLDivElement>({
        targetRef: stickyToolbarRef,
        onResize: (payload) => {
            if (stickyToolbarRef.current && typeof onResize === 'function') {
                onResize({ width: payload.width ?? 0, height: payload.height ?? 0 });
            }
        },
    });

    return createPortal(
        (
            <div
                className={`sticky-toolbar-container placement-${placement}`}
                style={{width: isSet(width) ? `${width}px` : '100%'}}
                ref={stickyToolbarRef} >
                <div className="sticky-toolbar">
                    {children}
                </div>
            </div>
        ),
        parentElement
    );
}

export default StickyToolbar;
